// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"english-rectangle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4V20H2L2 4L22 4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 4V20L2 20L2 4L22 4Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 9H6.5C6.22386 9 6 9.19188 6 9.42857V12M6 12H10M6 12V14.5714C6 14.8081 6.22386 15 6.5 15H10M14 15V9H17.5556C17.801 9 18 9.19188 18 9.42857V15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const EnglishRectangleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'english-rectangle',
    ref,
    icon: element,
  },
));

EnglishRectangleIcon.displayName = 'EnglishRectangleIcon';

export default EnglishRectangleIcon;
